import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputFile, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseCopy from '../base/base-copy.component'; 
import Model from './message-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import AppService from '../../services/app.service';
import OwnerPicklist from '../owner/owner-picklist.component';

interface IProps { 
    history: History;
    id?: number;
    caption?: string;
    successCaption?: string;
    astemplate?: string;
    datarow?: any;
    save?: boolean;
    onSave?: (data: any) => void;
    onError?: (data: any) => void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
    save: boolean;
}

export default class MessageCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: {...Model.defaultValue(), astemplate: this.props.astemplate || 'no', sent: this.props.astemplate==='yes'? 'no' : 'yes', },
            errors: null,
            datarowMedia: null,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = async(data: any) => {
        await this.setState({datarow: {...data, ...this.props.datarow}});
        await this.onLoadFile(this.props.datarow.image);
        this.setState({save: this.props.save || false});
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        if (data) {
            this.setState({errors: data, save: false});
            this.props.onError?.(data)
        }
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.attachmentId, files: data, ref: Model.endPointMedia, field:'attachment'}}});
    }

    private onSave = (data: any) => {
        this.setState({save: false});
        this.props.onSave?.(data)
    }
    
    private onChange(fieldName: string, value?: string) {
        var  html = this.state.datarow.html;
        if (fieldName==='text') html = this.state.datarow.text.replaceAll('\n','<br/>');

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, html: html,
            }
        }
        this.setState(nextState);
    }

    render() {

        return (
            //editable..
            <BaseCopy history={this.props.history} id={this.props.id} caption={this.props.disableView? ' ' : this.props.caption} buttonCaption={this.props.disableView? ' ' : ''} successCaption={this.props.successCaption}
                endPoint={Model.endPoint} model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError} save={this.state.save} onSave={this.onSave} disableAutoBack={this.props.disableView} disableBackButton={this.props.disableView} disableCard={this.props.disableView}>              
                {!this.props.disableView && 
                <>
                    <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                    <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                    <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                    {AppService.isAppFullVersion() &&
                    <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                        <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                    </InputPicklist>
                    }
                    <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} error={this.state.errors?.type} onChange={this.onChange} />
                    {this.props.astemplate!=='yes' &&
                    <InputSwitch name='sent' label='Send Now?' value={this.state.datarow.sent} error={this.state.errors?.sent} onChange={this.onChange}/>
                    }
                    {this.state.datarow.type==='email'?
                    <>
                    <InputEmail name='to' label='To' value={this.state.datarow.to} error={this.state.errors?.to} onChange={this.onChange} />
                    <InputEmail name='cc' label='Cc' value={this.state.datarow.cc} error={this.state.errors?.cc} onChange={this.onChange} />
                    <InputEmail name='bcc' label='Bcc' value={this.state.datarow.bcc} error={this.state.errors?.bcc} onChange={this.onChange} />
                    <InputEmail name='replyto' label='Reply to' value={this.state.datarow.replyto} error={this.state.errors?.replyto} onChange={this.onChange} />
                    </>
                    : 
                    <Input name='to' label='To' value={this.state.datarow.to} error={this.state.errors?.to} onChange={this.onChange} />
                    }
                    <Input name='subject' label='Subject' value={this.state.datarow.subject} error={this.state.errors?.subject} onChange={this.onChange} />
                    <InputMultiline name='text' label='Text' value={this.state.datarow.text} error={this.state.errors?.text} onChange={this.onChange} />
                    <InputFile name='attachmentUrl' label='Attachment' value={this.state.datarow.attachmentUrl} onLoad={this.onLoadFile} encode error={this.state.errors?.attachment} onChange={this.onChange} />
                </>
                }
            </BaseCopy>
        );
    }
}